module.exports = __webpack_public_path__ + "img/telefonische_aufnahme.e4cc27dd.svg";